"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = screenShareCount;
var _types = require("../../actions/screenShare/types");
function screenShareCount() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_SET_SCREEN_SHARE_COUNT) return action.payload;
  return state;
}